import { useOverlays } from "contexts/OverlayContext";
import { DeleteChartOfAccountsModal } from "./DeleteChartOfAccountsModal";

export const DeleteChartOfAccountsModalWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"deleteChartOfAccounts">(
        "deleteChartOfAccounts",
    );

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <DeleteChartOfAccountsModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
            accounts={overlayInfo.data.accounts}
        />
    );
};
